/**
 * formation-7h-b-125-interactif.js
 *
 * Couche interactive pour la Formation 7h B → 125 (permis A1 admin).
 * Format : voir passerelle-a2-a-interactif.js (briseGlace, qcm, statClef, videoUrl).
 */

export const FORMATION_B125_INTERACTIF = {
  briseGlaceOuverture: {
    titre: '🔥 Brise-glace — Avant de commencer',
    consigne: 'Lève la main pour répondre',
    question: 'Combien pense-t-on perdre de visibilité à moto par rapport à une voiture ?',
    options: [
      { label: '10 %', correct: false },
      { label: '30 %', correct: false },
      { label: '50 %', correct: false },
      { label: '70-80 %', correct: true },
    ],
    explication:
      'Un motard occupe 1 m² de surface frontale contre 5-6 m² pour une voiture. Les autres usagers te voient à peine. Ta survie passe par une visibilité ACTIVE : couleurs vives, position de chaussée, gestes nets.',
  },

  etapes: [
    {
      etape: 1,
      briseGlace:
        "Dis ton prénom + pourquoi tu fais cette formation aujourd'hui (loisir, trajet domicile-travail, conomies de carburant ?).",
      statClef: { valeur: '23%', label: 'des morts route sont à moto', detail: 'Alors que la moto = moins de 2% du trafic. Source ONISR 2024.' },
    },
    {
      etape: 2,
      qcm: {
        question: 'Combien pèse en moyenne une 125 ?',
        options: [
          { label: '80 kg', correct: false },
          { label: '130-160 kg', correct: true },
          { label: '200-220 kg', correct: false },
          { label: '300 kg', correct: false },
        ],
        explication:
          '130-160 kg selon les modèles. Le poids te « fuit » quand tu poses pied à terre sur une chaussée en dévers — attention aux trottoirs en pente !',
      },
      statClef: { valeur: '1 m²', label: 'Ta surface frontale visible', detail: 'À comparer aux 5-6 m² d’une voiture. Tu es INVISIBLE par défaut.' },
      videoUrl: null,
    },
    {
      etape: 3,
      qcm: {
        question: 'Quelle est la tolérance d’alcoolémie pour un jeune permis B (< 3 ans) ?',
        options: [
          { label: '0 g/L (zéro)', correct: false },
          { label: '0,2 g/L', correct: true },
          { label: '0,5 g/L', correct: false },
          { label: '0,8 g/L', correct: false },
        ],
        explication:
          '0,2 g/L max pour un permis probatoire ou apprenti. Au-delà : 6 points retirés + amende 135 € forfaitaire (R234-1). 1 seul verre standard = déjà trop.',
      },
      statClef: { valeur: '30 m', label: 'Distance d’arrêt à 50 km/h', detail: 'Réaction 1s + freinage 20m. Plus que la longueur d’un terrain de basket.' },
    },
    {
      etape: 4,
      qcm: {
        question: 'Qu’est-ce que le « contre-braquage » ?',
        options: [
          { label: 'Freiner brusquement à contre-sens', correct: false },
          { label: 'Pousser le guidon à gauche pour tourner à droite et inversement', correct: true },
          { label: 'Mettre les warnings pour avertir', correct: false },
          { label: 'Accélérer en virage', correct: false },
        ],
        explication:
          'En 2-roues au-delà de 15-20 km/h, tu tournes en POUSSANT le guidon du côté opposé. C’est physique (gyroscope). C’est CE qui te sauve en évitement.',
      },
      statClef: { valeur: '4 doigts', label: 'sur le levier de frein', detail: 'En formation et en urgence : amplitude maximale du freinage.' },
    },
    {
      etape: 5,
      briseGlace:
        'Tu es au feu rouge, un scooter à côté de toi te défie au départ. Comment te comportes-tu ?',
      qcm: {
        question: 'Le débridage d’un cyclomoteur entraîne quelle conséquence sur l’assurance ?',
        options: [
          { label: 'Aucune si tu déclares pas', correct: false },
          { label: 'Une majoration de 50 % sur la prime', correct: false },
          { label: 'Tu perds toute couverture en cas d’accident', correct: true },
          { label: 'Cela dépend de l’assureur', correct: false },
        ],
        explication:
          'Le débridage = exclusion d’assurance. La responsabilité civile peut couvrir les tiers mais TES dommages corporels ne seront PAS pris en charge. Et tu rembourseras tout (ou ta famille).',
      },
    },
    {
      etape: 6,
      briseGlace:
        'Sur quel exercice plateau penses-tu être le moins à l’aise aujourd’hui ? Slalom, demi-tour, huit, freinage d’urgence ?',
      statClef: { valeur: '2 sec', label: 'Distance de sécurité minimum', detail: 'Avec la voiture devant. ×2 sous la pluie. Sans exception.' },
    },
    {
      etape: 7,
      qcm: {
        question: 'En giratoire, dans quel ordre fais-tu tes contrôles ?',
        options: [
          { label: 'Cligno → rétro → contrôle direct', correct: false },
          { label: 'Rétro → cligno → contrôle direct', correct: true },
          { label: 'Contrôle direct → cligno → rétro', correct: false },
          { label: 'Aucun contrôle nécessaire si tu vois venir', correct: false },
        ],
        explication:
          'TOUJOURS : Rétro (anticipation) → Clignotant (intention) → Contrôle direct (angle mort). C’est ce qui te rend prévisible pour les autres usagers.',
      },
      statClef: { valeur: '×3', label: 'Plus de risque en agglo qu’en rase campagne', detail: 'Densité de carrefours, piétons, livraisons — l’agglomération est le terrain le plus dangereux à moto.' },
    },
    {
      etape: 8,
      briseGlace:
        "En UNE phrase : qu’est-ce que tu vas appliquer DÈS demain en moto ?",
      statClef: { valeur: '5 ans', label: 'Validité de l’attestation 7h', detail: 'Après 5 ans sans pratique de moto, tu devras refaire la formation. À conserver précieusement.' },
    },
  ],

  citationFinale: {
    texte: 'À moto, tu es invisible par défaut. Ta survie est une décision permanente.',
    auteur: 'Fédération Française des Motards en Colère',
  },
};

export default FORMATION_B125_INTERACTIF;
